import { Injectable } from '@angular/core';
import { SUPPORTED_LANGUAGES } from '../../../app/shared/constants';
import config from '../../../assets/config.json';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    private supportedLangs = SUPPORTED_LANGUAGES;
    private fallbackLocale = config.i18n.fallbackLanguage;

    constructor() {
        this.setLang();
    }

    public getItem(k: string): string {
        return localStorage.getItem(k);
    }

    public setItem(k: string, v: string): void {
        localStorage.setItem(k, v);
    }

    public getLocale(): string {
        return this.getItem('locale') ?? this.fallbackLocale;
    }

    private setLang() {
        const lsLocale = this.getLocale();
        const locale = lsLocale ? lsLocale : this.fallbackLocale;
        const validLang = this.supportedLangs.includes(locale.slice(0, 2));
        this.setItem('locale', validLang ? locale : 'en-GB');
    }
}
